/**
 * Hash a string for analytics purposes using a simple non-reversible hash.
 * Prevents raw session IDs from being sent to third-party analytics services.
 */
export function hashForAnalytics(value) {
  if (!value) return undefined;
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    const char = value.charCodeAt(i);
    hash = ((hash << 5) - hash + char) | 0;
  }
  return 'h_' + (hash >>> 0).toString(36);
}

export function trackEvent(name, params) {
  if (window.gtag) window.gtag('event', name, params);
}

export function trackPixel(eventName, params) {
  if (window.fbq) window.fbq('track', eventName, params);
}
